/**
 * Pixel matrix definitions for all 12 building kinds.
 * Each building is a 3x3 grid of palette color indices (8px blocks -> 24x24 pixels).
 *
 * Palette reference:
 *   0=black  1=white  2=red      3=green    4=blue     5=yellow
 *   6=cyan   7=magenta 8=brown    9=orange  10=lt green 11=lt blue
 *  12=pink  13=lt yell 14=dk gray 15=lt gray
 */

import { BuildingKind } from './client_message_protocol';

export const BUILDING_SPRITES: Record<BuildingKind, number[][]> = {
  [BuildingKind.SpiritRoot]: [
    [0, 3, 0],
    [8, 3, 8],
    [8, 8, 8],
  ],

  [BuildingKind.GatheringArray]: [
    [0, 6, 0],
    [6, 14, 6],
    [0, 6, 0],
  ],

  [BuildingKind.RefiningArray]: [
    [5, 14, 5],
    [14, 9, 14],
    [5, 14, 5],
  ],

  [BuildingKind.AlchemyFurnace]: [
    [2, 14, 2],
    [14, 2, 14],
    [14, 14, 14],
  ],

  [BuildingKind.Forge]: [
    [14, 9, 14],
    [9, 14, 9],
    [14, 14, 14],
  ],

  [BuildingKind.HerbFarm]: [
    [3, 3, 3],
    [8, 8, 8],
    [8, 8, 8],
  ],

  [BuildingKind.SwordTower]: [
    [2, 2, 2],
    [0, 14, 0],
    [14, 14, 14],
  ],

  [BuildingKind.DefenseTower]: [
    [4, 4, 4],
    [0, 14, 0],
    [14, 14, 14],
  ],

  [BuildingKind.SlowTrap]: [
    [14, 11, 14],
    [11, 14, 11],
    [14, 11, 14],
  ],

  [BuildingKind.PuppetBarracks]: [
    [8, 14, 8],
    [8, 8, 8],
    [14, 14, 14],
  ],

  [BuildingKind.TransporterStation]: [
    [14, 5, 14],
    [5, 9, 5],
    [14, 5, 14],
  ],

  [BuildingKind.PuppetWorkshop]: [
    [14, 7, 14],
    [7, 14, 7],
    [14, 14, 14],
  ],
};
